module.exports = __webpack_public_path__ + "img/search_black.ae0bb4bd.png";